import styled from 'styled-components';
export var FiltersRestore = styled.div.withConfig({
  displayName: "FiltersRestore",
  componentId: "sc-v2ril0-0"
})(["display:inline-block;padding:0 12px;border:none;cursor:pointer;font-size:15px;font-weight:500;line-height:38px;color:", ";text-align:left;", " ", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
}, function (_ref2) {
  var active = _ref2.active;
  return active ? "display: block;" : '';
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && "\n      opacity: 0.6;\n      cursor: no-drop;\n    ";
}, function (_ref4) {
  var hidden = _ref4.hidden;
  return hidden ? "display: none;" : '';
});